import React from "react";

import {
  OperatorUserListWidget
} from "@auto/users/__OperatorUserListWidget";

/*
 * Developer-owned composition point. Load operator_user_annex data here
 * and add project-specific columns/actions without changing generated widgets.
 */
const enrichRows = async (rows) => rows;
const extraColumns = [];

export const displayOperatorUserList = (gui) => ({
  uuid: "operator-user-list",
  view: () => (
    <OperatorUserListWidget
      gui={gui}
      enrichRows={enrichRows}
      extraColumns={extraColumns}
    />
  )
});

export default displayOperatorUserList;
